<template>
  <b-modal
    @bv::modal::hidden="resetForm"
    @bv::modal::hide="resetForm"
    hide-footer
    hide-header
    centered
    id="create-credit-card"
  >
    <validation-observer ref="CreditCardForm">
      <b-overlay :show="apiLoading" spinner-variant="primary" blur=".3" opacity=".75" rounded="sm">
        <b-form @submit.prevent="createCreditCard">
          <div class="card border-0">
            <div class="card-body">
              <div class="card-title">
                <h3>New Credit Card</h3>
              </div>
              <div class="row">
                <div class="col-md-18">
                  <validation-provider #default="{ errors }" name="card_number" rules="required|max:19">
                    <b-form-group
                      label-cols-sm="10"
                      label-cols-lg="9"
                      content-cols-sm
                      content-cols-lg="14"
                      label="Card Number"
                      label-for="card-number"
                    >
                      <b-form-input :state="errors.length > 0 ? false : null"
                                    @input="setCreditCard($event)"
                                    :value="formattedCreditCard"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </div>

                <div class="col-md-9">
                  <validation-provider #default="{ errors }" name="ExpiryMonth" rules="required|between:1,12|integer">
                    <b-form-group label-cols-sm="9" label-cols-lg="8" content-cols-sm content-cols-lg="10"
                                  label="Expiry Month">
                      <b-form-input :state="errors.length > 0 ? false : null" v-model="formData.expiryMonth"
                                    placeholder="MM"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </div>

                <div class="col-md-9">
                  <validation-provider #default="{ errors }" name="ExpiryYear" rules="required|min_value:23|integer|between:23,99|max:2">
                    <b-form-group label-cols-sm="9" label-cols-lg="8" content-cols-sm content-cols-lg="10"
                                  label="Expiry Year">
                      <b-form-input :state="errors.length > 0 ? false : null" v-model="formData.expiryYear"
                                    placeholder="YY"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </div>

                <div class="col-md-18">
                  <validation-provider #default="{ errors }" name="credit_card_firstname" rules="required">
                    <b-form-group label-cols-sm="10" label-cols-lg="9" content-cols-sm content-cols-lg="14"
                                  label="Cardholder First Name">
                      <b-form-input :state="errors.length > 0 ? false : null" v-model="formData.credit_card_firstname"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </div>

                <div class="col-md-18">
                  <validation-provider #default="{ errors }" name="credit_card_last_name" rules="required">
                    <b-form-group label-cols-sm="10" label-cols-lg="9" content-cols-sm content-cols-lg="14"
                                  label="Cardholder Last Name">
                      <b-form-input :state="errors.length > 0 ? false : null" v-model="formData.credit_card_lastname"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </div>

                <div class="col-md-18">
                  <validation-provider #default="{ errors }" name="cvv" rules="required|integer">
                    <b-form-group label-cols-sm="10" label-cols-lg="9" content-cols-sm content-cols-lg="14" label="CVV">
                      <b-form-input v-model="formData.cvv"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </div>

                <div class="col-md-18">
                  <validation-provider #default="{ errors }" name="Address" rules="required">

                    <b-form-group label-cols-sm="10" label-cols-lg="9" content-cols-sm content-cols-lg="14"
                                  label="Address">
                      <b-form-input :state="errors.length > 0 ? false : null"  v-model="formData.address"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </div>

                <div class="col-md-18">
                  <validation-provider #default="{ errors }" name="ZipCode" rules="required|integer">
                    <b-form-group label-cols-sm="10" label-cols-lg="9" content-cols-sm content-cols-lg="14"
                                  label="Zip Code">
                      <b-form-input :state="errors.length > 0 ? false : null" v-model="formData.zip"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </div>

                <div class="col-md-18">
                  <b-button type="submit" variant="primary">
                    <span v-if="apiLoading">
                      Saving...
                      <b-spinner small label="Small Spinner"></b-spinner>
                    </span>
                    <span v-else>Save</span>
                  </b-button>
                  <b-button variant="outline-dark" @click="cancelCreateCreditCard">Cancel</b-button>
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </b-modal>
</template>


<script>
import ApiMixin from '@core/mixin/ApiMixin'

export default {
  name: 'AddCard',
  mixins: [ApiMixin],
  data() {
    return {
      formData: {
        card_number: '',
        expiryYear: '',
        expiryMonth: '',
        cardholderName: '',
        address: '',
        zip: '',
        expire_date: '',
        cvv: ''
      }
    }
  },
  computed: {
    formattedCreditCard() {
      // This method formats the credit card number as the user types.
      // Here, we'll format the number in groups of four digits separated by space.

      let creditCardNumber = this.formData.card_number.replace(/\D/g, '');
      let formattedNumber = '';
      for (let i = 0; i < creditCardNumber.length; i += 4) {
        formattedNumber += creditCardNumber.slice(i, i + 4) + ' ';
      }
      return formattedNumber.slice(0, -1); // Remove the trailing hyphen
    }
  },
  methods: {
    createCreditCard() {
      this.$refs.CreditCardForm.validate().then(success => {
        if (success) {

          this.formData.expire_date = this.formData.expiryMonth + "/" + this.formData.expiryYear
          this.formData.expiryYear = '20' + this.formData.expiryYear
          // You can submit the form data to your API here
          this.post('/customer_cards', {
            card: this.formData
          }).then(() => {
            this.$emit('created');
            this.resetForm();
            this.$bvModal.hide('create-credit-card');
          });
          this.resetForm();
          this.$bvModal.hide('create-credit-card');
        }
      })
    },
    cancelCreateCreditCard() {
      this.resetForm();
      this.$bvModal.hide('create-credit-card');
    },
    setCreditCard(val) {
      this.formData.card_number = val.replace(/ /g,"");
    },
    resetForm() {
      this.formData = {
        card_number: '',
        expiryYear: '',
        expiryMonth: '',
        cardholderName: '',
        address: '',
        zipCode: '',
        expire_date: '',
        cvv: ''
      }
    }
  }
}
</script>
<style scoped>

</style>
